function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", null, React.createElement("path", {
  fill: "#4285F4",
  d: "M18.816 9.818c0-.68-.061-1.335-.175-1.963H9.6v3.713h5.167c-.223 1.2-.9 2.217-1.916 2.897v2.41h3.102c1.816-1.672 2.863-4.133 2.863-7.057z",
  transform: "translate(-765 -431) translate(662 423) translate(103) translate(0 8) translate(2 2)"
}), React.createElement("path", {
  fill: "#34A853",
  d: "M9.6 19.2c2.592 0 4.765-.86 6.353-2.326l-3.102-2.409c-.86.576-1.96.917-3.251.917-2.5 0-4.617-1.689-5.372-3.958H1.021v2.487C2.601 17.05 5.847 19.2 9.6 19.2z",
  transform: "translate(-765 -431) translate(662 423) translate(103) translate(0 8) translate(2 2)"
}), React.createElement("path", {
  fill: "#FBBC05",
  d: "M4.228 11.424c-.192-.576-.3-1.191-.3-1.824s.108-1.248.3-1.824V5.289H1.021C.371 6.585 0 8.05 0 9.6c0 1.55.37 3.015 1.021 4.311l3.207-2.487z",
  transform: "translate(-765 -431) translate(662 423) translate(103) translate(0 8) translate(2 2)"
}), React.createElement("path", {
  fill: "#EA4335",
  d: "M9.6 3.818c1.41 0 2.675.485 3.67 1.436L16.023 2.5C14.361.951 12.188 0 9.6 0c-3.753 0-7 2.151-8.579 5.289l3.207 2.487C4.983 5.506 7.1 3.818 9.6 3.818z",
  transform: "translate(-765 -431) translate(662 423) translate(103) translate(0 8) translate(2 2)"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/google-logo.0ae8c1f1.svg";
export { SvgComponent as ReactComponent };